export class Author {
    public id: string;
    public uuid?: string;
    public contactUrl?: string;
    public agilityContactId: string;
    public agilityContactURL: string;
    public name: string;
}
